import React from "react";
import { Link } from "react-router-dom";
import "./Galleria.css";

import arte1 from "../assets/artemisia/arteuno.jpg";
import arte2 from "../assets/artemisia/artedue.jpg";

const Artemisia = () => {
  return (
    <div className="galleria">
      <figure className="opera">
        <img src={arte1} alt="Artemisia 1" draggable="false" />
      </figure>

      <figure className="opera">
        <img src={arte2} alt="Artemisia 2" draggable="false" />
      </figure>

      <div className="opera-testo">
        <div>
          <p>
            ‘Artemisia: un progetto contro la violenza di genere’ nasce
            nell’estate del 2021 per le strade di Napoli. Il vissuto di
            Artemisia Gentileschi è stato l’input di questa iniziativa: la
            semplice idea di renderle omaggio ricreando il suo autoritratto più
            famoso si trasforma nell’opportunità di coinvolgere il pubblico.
            Come?
          </p>
          <p>
            ‘‘Vorrei dedicare questo dipinto a tutte le donne. Se sei donna
            (cis, trans) ed hai subito una qualsiasi violenza, ti invito a
            firmare questo tributo.’’ Così recitava il messaggio alle mie spalle
            mentre il quadro prendeva vita attraverso sessioni di live painting
            nel cuore di Napoli. Ogni volta che una donna lasciava il proprio
            nome sulla tela, vedevo la vita vissuta unirsi all’arte.
          </p>
          <p>
            Il dipinto, una volta terminato, è stato donato all’associazione
            “Volontarie del Telefono Rosa Napoli”, che dedica la sua attività al
            supporto delle donne vittima di violenza sul territorio campano,
            verso la quale è stata anche creata una raccolta fondi di
            beneficenza.
          </p>
        </div>
      </div>

      <Link to="/Home" className="torna">
        Torna alla home
      </Link>
    </div>
  );
};

export default Artemisia;
